import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { useCallback } from 'react';
import { rootRoute } from '@/app/root-route.tsx';
import { type SubmissionsSearch, submissionsSearchSchema } from './search.ts';

const SubmissionsListPage = lazyRouteComponent(
  () => import('./SubmissionsListPage.tsx'),
  'SubmissionsListPage',
);
const SubmissionDetailPage = lazyRouteComponent(
  () => import('./SubmissionDetailPage.tsx'),
  'SubmissionDetailPage',
);

export const submissionsListRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/live/submissions',
  validateSearch: (search: Record<string, unknown>): SubmissionsSearch =>
    submissionsSearchSchema.parse(search),
  component: function SubmissionsListRouteComponent() {
    const search = submissionsListRoute.useSearch();
    const navigate = submissionsListRoute.useNavigate();
    const onSearchChange = useCallback(
      (patch: Partial<SubmissionsSearch>) =>
        navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
      [navigate],
    );
    return <SubmissionsListPage search={search} onSearchChange={onSearchChange} />;
  },
});

/** The form is a dialog on the list page now; keeps old links and bookmarks working. */
export const newSubmissionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/live/submissions/new',
  beforeLoad: () => {
    throw redirect({ to: '/live/submissions', search: { new: true }, replace: true });
  },
});

export const submissionDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/live/submissions/$requestId',
  component: function SubmissionDetailRouteComponent() {
    const { requestId } = submissionDetailRoute.useParams();
    return <SubmissionDetailPage requestId={requestId} />;
  },
});
